module.exports = __webpack_public_path__ + "img/位图@2x.cfefa579.png";